import React from 'react'
import "./Layout.css"
import Footer from '../Footer/Footer'
import Header from '../Header/Header'

export default function Layout(
    {
        children,
        isAdmin,
        setIsAdmin
    }
) {
  return (
    <>
        <Header isAdmin={isAdmin} setIsAdmin={setIsAdmin}/>
        <main>{children}</main>
        <Footer />
    </>
  )
}
